.recipientList {
  padding-bottom: 10px;
}

.questionsActions {
  display: flex;
  flex-direction: row;

  & a:not(:first-child) {
    margin-left: 1em;
  }
}

.inputDescription {
  margin-top: -0.75em;
  margin-bottom: 0.4em;
}

.extraSurveyPartItem {
  margin-bottom: 1em;
}

.header {
  & th {
    padding-left: 1.5em;
    padding-top: 1em;
    min-width: 4em;
    padding-bottom: 0.5em;
  }
}

.row {
  & td {
    padding: 0.5em 1.5em;
    min-width: 5em;
  }
}

.row:nth-child(odd) {
  background-color: var(--silver);
}

.degreeProgramSurveyTitleStaticPart {
  font-weight: bold;
  font-size: 1.1em;
  margin-right: 1em;
}

.degreeProgramSurveyTitlePeriod {
  width: 12em;
  margin-right: 1em;
}

.degreeProgramSurveyTitleExtraPart {
  width: 25em !important;
}
